 var owl = jQuery('.home_slider .owl-carousel');
      owl.owlCarousel({
        margin: 0,
		nav: false,
        dots: true,
        loop: true,
        autoplay:true,
        autoplayTimeout:20000,
        autoplayHoverPause:false,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 1
          },
          1000: {
            items: 1
          },
          1200: {
            items: 1
          }
        }
});

//eye icon functionlity
function changePasswordType(passwordTxtId) {
    // toggle the type attribute
  const password = document.querySelector("#"+passwordTxtId);
    const type = password.getAttribute("type") === "password" ? "text" : "password";
    password.setAttribute("type", type);
  if(type == 'password'){
    $('#password-open-eye-icon').css('display','block');
    $('#password-closed-eye-icon').css('display','none');
  }else{
    $('#password-open-eye-icon').css('display','none');
    $('#password-closed-eye-icon').css('display','block');
  }
}
var activeTabName = 'All';
var key = 'GZYTFGL67XJNO79C7R11';      //'cc70f69f-3626-46e9-b4fa-2a16189378ff';
var unknown = "Yankeekicks";
function callDropInBlogForBanner() {
    fetch('https://api.dropinblog.com/v1/json/?b='+key+'&limit=1',{
      method:"GET"
    })
    .then((response) => response.json())
    .then((result) => {
      if(result.data.posts.length > 0)
      {
        let post = result.data.posts.pop();
        let authImage = "";
                      if(post.author?.photo == null || post.author?.photo == ""){
                        authImage = "<svg width='37' height='37' viewBox='0 0 37 37' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M0.0625 18.4302C0.0625 8.48905 8.12138 0.430176 18.0625 0.430176V0.430176C28.0036 0.430176 36.0625 8.48905 36.0625 18.4302V18.4302C36.0625 28.3713 28.0036 36.4302 18.0625 36.4302V36.4302C8.12138 36.4302 0.0625 28.3713 0.0625 18.4302V18.4302Z' fill='#FFFFFF'/><path d='M18.0625 20.9302C20.8239 20.9302 23.0625 18.6916 23.0625 15.9302C23.0625 13.1688 20.8239 10.9302 18.0625 10.9302C15.3011 10.9302 13.0625 13.1688 13.0625 15.9302C13.0625 18.6916 15.3011 20.9302 18.0625 20.9302Z' stroke='#64626A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/><path d='M10.4844 25.3051C11.2523 23.9748 12.3569 22.87 13.6872 22.1019C15.0174 21.3338 16.5264 20.9294 18.0625 20.9294C19.5986 20.9294 21.1076 21.3338 22.4378 22.1019C23.7681 22.87 24.8727 23.9748 25.6406 25.3051' stroke='#64626A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'></svg>"
                      }else{
                        authImage = "<img class='yk-banner-post-author-img' id='banner-post-author-img' src='"+ post.author?.photo +"'>";                        
                      }
        console.log("Image "+ post.featuredImage);
        if(post.id==2418){
          $('#banner-img').attr("src","https://io.dropinblog.com/uploaded/blogs/34240971/files/featured/FszkIBwXwAwDWBB_2.jpeg"); 
        }else{
          $('#banner-img').attr("src",post.featuredImage);
        }
        
        $('#banner-post-title').append(post.title);
        $('#banner-post-desc').append(post.summary);
        $('#banner-post-author').append(post.author?.name??unknown);
        $('#auth-image').append(authImage);
        $('#banner-post-link').attr("href","/a/blog/"+post.slug);

      }

    })
    .catch((error) => {
      console.error('Error:', error);
    });
    }

      function callDropInBlogReleaseMonth() {
             fetch('https://api.dropinblog.com/v1/json/?b='+key+'&limit=3',{
                  method:"GET"
                })
                .then((response) => response.json())
                .then((result) => {
                  if(result.data.posts.length > 0)
                  {
                    // let post = (result.data.posts).slice(-3);
                    let i =0;
                    for(let post of (result.data.posts).slice(-3)){
                      let category = '';
                      if(post.categories.length > 0){
                        for (let cat of post.categories) {
                            category = cat.title;
                          break;
                        }
                      }
                      let authImage = "";
                      if(post.author?.photo == null || post.author?.photo == ""){
                        authImage = "<svg width='37' height='37' viewBox='0 0 37 37' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M0.0625 18.4302C0.0625 8.48905 8.12138 0.430176 18.0625 0.430176V0.430176C28.0036 0.430176 36.0625 8.48905 36.0625 18.4302V18.4302C36.0625 28.3713 28.0036 36.4302 18.0625 36.4302V36.4302C8.12138 36.4302 0.0625 28.3713 0.0625 18.4302V18.4302Z' fill='#CBCACE'/><path d='M18.0625 20.9302C20.8239 20.9302 23.0625 18.6916 23.0625 15.9302C23.0625 13.1688 20.8239 10.9302 18.0625 10.9302C15.3011 10.9302 13.0625 13.1688 13.0625 15.9302C13.0625 18.6916 15.3011 20.9302 18.0625 20.9302Z' stroke='#64626A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/><path d='M10.4844 25.3051C11.2523 23.9748 12.3569 22.87 13.6872 22.1019C15.0174 21.3338 16.5264 20.9294 18.0625 20.9294C19.5986 20.9294 21.1076 21.3338 22.4378 22.1019C23.7681 22.87 24.8727 23.9748 25.6406 25.3051' stroke='#64626A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'></svg>"
                      }else{
                        authImage = "<img class='month-post-author-img' id='month-post-author-img-"+ i+"' src='"+ post.author?.photo +"'>";
                        
                      }
                      if(post.id==2418){
                         $('.cards').append("\
                                         <a href='/a/blog/"+post.slug+"'>\
                                         <div class='card'>\
                                           <div class='month-post-img-wrapper'>\
                                         <img class='month-post-img' id='month-img-"+ i+"' src='https://io.dropinblog.com/uploaded/blogs/34240971/files/featured/FszkIBwXwAwDWBB_2.jpeg'>\
                                          </div>\
                                         <div class='card-body'>\
                                         <div class='yk-post-category-info'>\
                                         <spap class='month-post-category' id='month-post-title-"+ i+"'>"+category +"</span>\
                                           <span>---</span>\
                                         <span class='month-post-readtime' id='month-post-readtime-"+ i+"'>"+ post.readtime +"</span>\
                                          </div>\
                                             <div class='yk-post-title-wrapper'>\
                                         <p class='month-post-title' id='month-post-title-"+ i+"'>"+ post.title +"</p>\
                                            </div>\
                                          <div class='yk-post-title-wrapper'>\
                                         <p class='month-post-desc' id='month-post-desc-"+ i+"'>"+ post.summary +"</p>\
                                          </div>\
                                         <div class='yk-postbottom-info'>\
                                         <div class='yk-author-wrapper'>\
                                            "+authImage+"\
                                            <p class='month-post-author' id='month-post-author-"+ i+"'>"+ (post.author ? post.author?.name : unknown) ?? unknown +"</p>\
                                        </div>\
                                         <p class='month-post-date' id='month-post-date-"+ i+"'>"+ formatDate(post.publishedAt) +"</p>\
                                            </div>\
                                         </div>\
                                         </div></a>\
                                        ");
                        
                      }else{
                    $('.cards').append("\
                                         <a href='/a/blog/"+post.slug+"'>\
                                         <div class='card'>\
                                           <div class='month-post-img-wrapper'>\
                                         <img class='month-post-img' id='month-img-"+ i+"' src='"+post.featuredImage+"'>\
                                          </div>\
                                         <div class='card-body'>\
                                         <div class='yk-post-category-info'>\
                                         <spap class='month-post-category' id='month-post-title-"+ i+"'>"+category +"</span>\
                                           <span>---</span>\
                                         <span class='month-post-readtime' id='month-post-readtime-"+ i+"'>"+ post.readtime +"</span>\
                                          </div>\
                                             <div class='yk-post-title-wrapper'>\
                                         <p class='month-post-title' id='month-post-title-"+ i+"'>"+ post.title +"</p>\
                                            </div>\
                                          <div class='yk-post-title-wrapper'>\
                                         <p class='month-post-desc' id='month-post-desc-"+ i+"'>"+ post.summary +"</p>\
                                          </div>\
                                         <div class='yk-postbottom-info'>\
                                         <div class='yk-author-wrapper'>\
                                            "+authImage+"\
                                            <p class='month-post-author' id='month-post-author-"+ i+"'>"+ (post.author ? post.author?.name : unknown) ?? unknown +"</p>\
                                        </div>\
                                         <p class='month-post-date' id='month-post-date-"+ i+"'>"+ formatDate(post.publishedAt) +"</p>\
                                            </div>\
                                         </div>\
                                         </div></a>\
                                        ");
                      }
                    }
                  }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  function callDropInBlogCategoryWise(post_category) {
                let url = '';
                let category = '';
                if(post_category == 'ALL'){
                  category = '';
                  $('#tabs-button-view-aticles').attr("href","/a/blog");
                  url = 'https://api.dropinblog.com/v1/json/?b='+key;
                }else{
                  url ='https://api.dropinblog.com/v1/json/?b='+key+'&category='+post_category;
                  category = post_category;
                  $('#tabs-button-view-aticles').attr("href","/a/blog/category/"+post_category);
                }
                fetch(url,{
                  method:"GET"
                })
                .then((response) => response.json())
                .then((result) => {
                  $('.blogsblogin').empty();
                  let i =0;
                    for(let post of result.data.posts){
                      let category = '';
                      if(post_category == 'ALL'){
                          if(post.categories.length > 0){
                            for (let cat of post.categories) {
                                category = cat.title;
                              break;
                            }
                          }
                      }else{
                            category = post_category;
                      }
                      
                      if(category == ''){
                        category = '&nbsp;';
                      }
                      $('.blogsblogin').append("\
                                           <a href='/a/blog/"+post.slug+"'>\
                                          <div class='card'>\
                                           <div class='month-post-img-wrapper'>\
                                               <img class='month-post-img' id='month-img-"+ i+" ' src='"+post.featuredImage+"'>\
                                               </div>\
                                               <div class='card-body'>\
                                            <div class='yk-post-category-info'>\
                                               <spap class='month-post-category' id='month-post-title-"+ i+"'>"+category +"</span>\
                                               </div>\
                                               <div class='yk-post-title-wrapper'>\
                                               <p class='month-post-title' id='month-post-title-"+ i+"'>"+ post.title +"</p>\
                                            </div>\
                                               <div class='yk-postbottom-info'>\
                                               <div class='yk-post-author-info'>\
                                               <span>By</span>\
                                            <span class='month-post-author-red' id='month-post-author-"+ i+"'>"+ (post.author ? post.author?.name : unknown) ?? unknown +"</span>\
                                             </div>\
                                               <div>\
                                               <span>Published on</span>\
                                                <span class='month-post-date' id='month-post-date-"+ i+"'>"+ formatDate(post.publishedAt) +"</span>\
                                               </div>\
                                               </div>\
                                               </div>\
                                            </div></a>\
                                        ");
                    }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  function tabsOnClick(evt, tab,activeTabName) {
      activeTabName =activeTabName;
      callDropInBlogCategoryWise(activeTabName)
      var i, tabcontent, tablinks;
      // tabcontent = document.getElementsByClassName("tabcontent-cus");
      // for (i = 0; i < tabcontent.length; i++) {
      //   tabcontent[i].style.display = "none";
      // }
      tablinks = document.getElementsByClassName("tablinks-cus");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      // document.getElementById(tab).style.display = "block";
      evt.currentTarget.className += " active";
}
//document.getElementById("tab-cus-active").click();

function callDropInBlogHomePage() {
    fetch('https://api.dropinblog.com/v1/json/?b=' + key,{
      method:"GET"
    })
    .then((response) => response.json())
    .then((result) => {
      if(result.data.posts.length > 0)
      {
        let i =0;
        for(let post of (result.data.posts).slice(-3)){
           let category = '';
              if(post.categories.length > 0){
                for (let cat of post.categories) {
                    category = cat.title;
                  break;
                }
              }
           let authImage = "";
                      if(post.author?.photo == null || post.author?.photo == ""){
                        authImage = "<svg width='37' height='37' viewBox='0 0 37 37' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M0.0625 18.4302C0.0625 8.48905 8.12138 0.430176 18.0625 0.430176V0.430176C28.0036 0.430176 36.0625 8.48905 36.0625 18.4302V18.4302C36.0625 28.3713 28.0036 36.4302 18.0625 36.4302V36.4302C8.12138 36.4302 0.0625 28.3713 0.0625 18.4302V18.4302Z' fill='#CBCACE'/><path d='M18.0625 20.9302C20.8239 20.9302 23.0625 18.6916 23.0625 15.9302C23.0625 13.1688 20.8239 10.9302 18.0625 10.9302C15.3011 10.9302 13.0625 13.1688 13.0625 15.9302C13.0625 18.6916 15.3011 20.9302 18.0625 20.9302Z' stroke='#64626A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/><path d='M10.4844 25.3051C11.2523 23.9748 12.3569 22.87 13.6872 22.1019C15.0174 21.3338 16.5264 20.9294 18.0625 20.9294C19.5986 20.9294 21.1076 21.3338 22.4378 22.1019C23.7681 22.87 24.8727 23.9748 25.6406 25.3051' stroke='#64626A' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'></svg>"
                      }else{
                        authImage = "<img class='month-post-author-img' id='month-post-author-img-"+ i+"' src='"+ post.author?.photo +"'>";
                        
                      }
          
          $('.cards-home-blogs').append("\
                                  <a href='/a/blog/"+post.slug+"'>\
                                 <div class='card'>\
                                   <div class='month-post-img-wrapper'>\
                                 <img class='month-post-img' id='month-img-"+ i+"' src='"+post.featuredImage+"'>\
                                  </div>\
                                 <div class='card-body'>\
                                 <div class='yk-post-category-info'>\
                                 <spap class='month-post-category' id='month-post-title-"+ i+"'>"+category +"</span>\
                                   <span>---</span>\
                                 <span class='month-post-readtime' id='month-post-readtime-"+ i+"'>"+ post.readtime +"</span>\
                                  </div>\
                                     <div class='yk-post-title-wrapper'>\
                                 <p class='month-post-title' id='month-post-title-"+ i+"'>"+ post.title +"</p>\
                                    </div>\
                                  <div class='yk-post-title-wrapper'>\
                                 <p class='month-post-desc' id='month-post-desc-"+ i+"'>"+ post.summary +"</p>\
                                  </div>\
                                 <div class='yk-postbottom-info'>\
                                 <div class='yk-author-wrapper'>\
                                   "+authImage+"\
                                     <p class='month-post-author' id='month-post-author-"+ i+"'>"+ (post.author ? post.author?.name : unknown) ?? unknown +"</p>\
                                </div>\
                                 <p class='month-post-date' id='month-post-date-"+ i+"'>"+ formatDate(post.publishedAt) +"</p>\
                                    </div>\
                                 </div>\
                                 </div></a>\
                            ");
        }
      }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

 function formatDate(str) {
    let spt_str = str.split(',');
   return spt_str[0]
  // return result;
 }
function hideOtherLocation(){
  var text = $('#location-dropdown').find(":selected").text();
  var location = $('#location-dropdown').find(":selected").val();
  if($('.select-location-name').length){
    $('.select-location-name').text(text)
  }
   if(location =='location1'){
     $('.location1').css('display','block');
     $('.location2').css('display','none');
     $('.location3').css('display','none');
   }
  else if(location =='location2'){
     $('.location1').css('display','none');
     $('.location2').css('display','block');
     $('.location3').css('display','none');
   }
  else{
    $('.location1').css('display','none');
     $('.location2').css('display','none');
     $('.location3').css('display','block');
  }
}




